import {
    CHAT_DELETE_MESSAGE,
    CHAT_FETCH_MESSAGES_PAGE,
    CHAT_MARK_MESSAGE_AS_READ,
    CHAT_OPEN_NEW_CHAT,
    CHAT_PREPARE_CHANNEL_TO_PUSH,
    CHAT_PUSH_CHANNEL,
    CHAT_PUSH_MESSAGE,
    CHAT_RESET_LOADED_STATE,
    CHAT_SET_ACTIVE_CHAT,
    CHAT_SET_CHANNELS,
    CHAT_SET_ERROR,
    CHAT_SET_FORM_REPLY_TO,
    CHAT_SET_INIT_DATA,
    CHAT_SET_INITIALIZING,
    CHAT_SET_MESSAGES_PAGE,
    CHAT_SET_NOW_LOADING_MESSAGES_PAGE,
    CHAT_SET_PAGE,
    CHAT_SET_PAGE_CONTENT_HEIGHT,
    CHAT_SET_SCROLL_BOTTOM,
    CHAT_SET_SEARCH_TERM,
    CHAT_UPDATE_MESSAGE
} from '@src/_redux/chats/constants';
import {IReduxChatsState, IReduxChatsStateChat} from '@src/@interfaces';
import {IChatChannelModel} from '@src/@interfaces/models/Chat/IChatChannelModel';
import {ICommentModel} from '@src/@interfaces/models/Comment/ICommentModel';
import AccessDeniedHttpException from '@src/exceptions/AccessDeniedHttpException';

export const chatSetSearchTerm = (searchTerm: string | null) => ({
    type: CHAT_SET_SEARCH_TERM,
    payload: {searchTerm},
});

export const chatSetInitializingState = (state: boolean) => ({
    type: CHAT_SET_INITIALIZING,
    payload: {loading: state},
});

export const chatResetLoadedState = () => ({
    type: CHAT_RESET_LOADED_STATE,
});

export const chatSetInitData = (
    users: IReduxChatsState['users'],
    channels: IReduxChatsState['channels'],
) => ({
    type: CHAT_SET_INIT_DATA,
    payload: {users, channels},
});

export const chatSetError = (error: Error | string | null, uuid: string | null = null) => ({
    type: CHAT_SET_ERROR,
    payload: {
        uuid,
        error: error == null ? null : {
            message: typeof error === 'string' ? error : error?.message,
            isFatal: typeof error === 'object' && error instanceof AccessDeniedHttpException,
        }
    },
});

export const chatSetActiveChat = (uuid: string | null) => ({
    type: CHAT_SET_ACTIVE_CHAT,
    payload: {uuid},
});

export const chatPrepareChannelToPush = (channel: IChatChannelModel) => ({
    type: CHAT_PREPARE_CHANNEL_TO_PUSH,
    payload: {channel},
});

export const chatPushChannel = (channel: IReduxChatsState['channels'][number]) => ({
    type: CHAT_PUSH_CHANNEL,
    payload: {channel},
});

export const chatSetChannels = (channels: IReduxChatsState['channels']) => ({
    type: CHAT_SET_CHANNELS,
    payload: {channels},
});

export const chatPushMessage = (message: ICommentModel, chatUUID: string) => ({
    type: CHAT_PUSH_MESSAGE,
    payload: {message, chatUUID},
});

export const chatUpdateMessage = (message: ICommentModel, chatUUID: string) => ({
    type: CHAT_UPDATE_MESSAGE,
    payload: {message, chatUUID},
});

export const chatDeleteMessage = (message: ICommentModel | string | number, chatUUID: string) => ({
    type: CHAT_DELETE_MESSAGE,
    payload: {message, chatUUID},
});

export const chatOpenNewChat = (uuid: string, entityOrChannelId: string | number | NonNullable<IReduxChatsStateChat['entity']>) => ({
    type: CHAT_OPEN_NEW_CHAT,
    payload: Object.assign(
        {uuid},
        typeof entityOrChannelId === 'object' ? {entity: entityOrChannelId} : {},
        typeof entityOrChannelId !== 'object' ? {channelId: entityOrChannelId} : {},
    ),
});

export const chatFetchMessagesPage = (chatUUID: string, page: number) => ({
    type: CHAT_FETCH_MESSAGES_PAGE,
    payload: {page, chatUUID},
});

export const chatSetNowLoadingMessagesPage = (chatUUID: string, page: number) => ({
    type: CHAT_SET_NOW_LOADING_MESSAGES_PAGE,
    payload: {page, chatUUID},
});

export const chatSetMessagesPage = (chatUUID: string, page: number, messages: ICommentModel[]) => ({
    type: CHAT_SET_MESSAGES_PAGE,
    payload: {page, chatUUID, messages},
});

export const chatSetActivePage = (chatUUID: string, page: number) => ({
    type: CHAT_SET_PAGE,
    payload: {page, chatUUID},
});

export const chatSetPageContentHeight = (chatUUID: string, page: number, contentHeight: number | null) => ({
    type: CHAT_SET_PAGE_CONTENT_HEIGHT,
    payload: {page, chatUUID, contentHeight},
});

export const chatSetScrollBottom = (chatUUID: string, scrollBottom: number | null) => ({
    type: CHAT_SET_SCROLL_BOTTOM,
    payload: {chatUUID, scrollBottom},
});

export const chatMarkMessageAsRead = (markId: string | number, commentId: string | number, viewerId: string | number) => ({
    type: CHAT_MARK_MESSAGE_AS_READ,
    payload: {markId, commentId, viewerId},
});

export const chatSetFormReplyTo = (chatUUID: string, replyTo: string | number | null) => ({
    type: CHAT_SET_FORM_REPLY_TO,
    payload: {chatUUID, replyTo},
});

export const chatResetFormReplyTo = (chatUUID: string) => ({
    type: CHAT_SET_FORM_REPLY_TO,
    payload: {chatUUID, replyTo: null},
});
